(() => {
  const GetURLParams = (param) => {
    let params = new URLSearchParams(window.location.search);
    return params.get(param);
  };

  let SESSION_FRAMES_KEY = '_frames';
  let SESSION_FRAMES = JSON.parse(sessionStorage.getItem(SESSION_FRAMES_KEY)) || {};

  const LoadFrames = async (BRAND, context) => {
    let section_id = 'collection-frames';
    // fetch collection without "frame" for full list
    let path = window.location.pathname;
    if (path.indexOf('/collections/') == -1) {
      path = '/collections/replacement-lenses';
    }
    let url = `${ path }?filter.p.m.product.brand=${BRAND}&sections=${section_id}`;
    // console.log(url);
    let frames = [];
    let paginate;

    if (!context && !document.querySelector('#FacetFiltersForm')) return;

    const Load = async (page) => {
      let page_url = encodeURI(`${ url }&page=${ page }`);
      let res = await fetch(page_url, {cache: 'force-cache'}).then(res => res.json());
      if (!res[section_id]) return;

      let parser = new DOMParser();
      let $section = parser.parseFromString(res[section_id], 'text/html').body.querySelector('[data-frames]');

      let p_frames = JSON.parse($section.dataset.frames).flat();
      if (!paginate) {
        paginate = JSON.parse($section.dataset.paginate);
      }

      frames = [...new Set([...frames, ...p_frames])].sort();
      document.dispatchEvent(new CustomEvent('update:frames_list', {detail: {frames}}));
      if (page == paginate.pages) {
        SESSION_FRAMES[BRAND] = frames;
        sessionStorage.setItem(SESSION_FRAMES_KEY, JSON.stringify(SESSION_FRAMES));
        document.dispatchEvent(new CustomEvent('frames:loading:complete', {detail: {frames}}));
      }
    }

    let px = [];
    await Load(1);

    for(let n = 2; n <= paginate.pages; n++) {
      px.push(Load(n));
    }
    await Promise.all(px);
    // console.log(frames);
  }
  window.onload = () => {
    LoadFrames('Oakley');
  }

  document.addEventListener('alpine:init', () => {
    let SELECTED_FILTERS = {};
    [...document.querySelectorAll('#FacetFiltersForm details')].forEach(($item) => {
      let filter_type = $item.dataset.filter_type;
      let param_name = $item.dataset.param_name;
      SELECTED_FILTERS[filter_type] = GetURLParams(param_name);
    });

    Alpine.data('FacetFiltersForm', () => ({
      SELECTED_FILTERS: SELECTED_FILTERS,
      flags: {
        is_filtered: false,
        is_MobileForm: false
      },
      init() {
        let am = this;
        am.UpdateFlags();
        document.addEventListener('facets:updated', () => {
          am.$el.querySelectorAll('details').forEach(($details) => {
            let filter_type = $details.dataset.filter_type;
            if (filter_type) {
              let param_name = $details.dataset.param_name;
              SELECTED_FILTERS[filter_type] = GetURLParams(param_name);        
            }
          });
          am.SELECTED_FILTERS = {...SELECTED_FILTERS};
          am.UpdateFlags();
        });

        am.$watch('SELECTED_FILTERS', am.UpdateFrameRemove.bind(am));
        am.UpdateFrameRemove();
        document.addEventListener('remove-frame', (e) => {
          // console.log(e)
          am.SELECTED_FILTERS.frame = '';
          am.UpdateFrameRemove();
        });

        document.body.addEventListener('trigger:filter:submit', Alpine.debounce(() => {
          const isDesktop = window.matchMedia('(min-width: 749px)').matches;
          if (isDesktop && am.flags.is_MobileForm) return;
          if (!isDesktop && !am.flags.is_MobileForm) return;

          let searchParams = new URLSearchParams(new FormData(am.$el));
          // remove blank values
          let paramsToDelete = [];
          searchParams.forEach((value, key) => {
            if (value == '') {
              paramsToDelete.push(key);
            }
          });
          paramsToDelete.forEach(key => {
            searchParams.delete(key);
          });
          let event_detail = {searchParams: searchParams.toString(), form: am.$el};
          document.body.dispatchEvent(new CustomEvent('FacetFilters:submit:ajax', { detail: event_detail }));
        }, 100));
      },
      UpdateFlags() {
        let am = this;
        am.flags.is_filtered = Object.values(SELECTED_FILTERS).filter(value => value !== '').length !== 0;
        am.flags.is_MobileForm = am.$el.id == 'FacetFiltersFormMobile';
      },
      UpdateFrameRemove() {
        let am = this;
        let $removeFrame = am.flags.is_MobileForm ? document.querySelector('.facet-remove-frame-mobile') : am.$el.querySelector('.facet-remove-frame');
        if (!$removeFrame) return;
        $removeFrame.classList.toggle('hidden', !am.SELECTED_FILTERS['frame']);
        let params = new URLSearchParams(window.location.search);
        params.delete('filter.p.m.product.frame');
        $removeFrame.querySelector('a').setAttribute('href', `${window.location.pathname}?${params.toString()}`);
        $removeFrame.querySelector('.selected-frame').textContent = `Frame: ${am.SELECTED_FILTERS['frame']}`;
      },
      e_OnFilterChange(e) {
        let am = this;
        // Reset "frame" when "brand" selected
        if (e.target.name == 'filter.p.m.product.brand') {
          am.$el.querySelector('[name="filter.p.m.product.frame"]').value = '';
        }

        document.body.dispatchEvent(new CustomEvent('trigger:filter:submit'));
      }
    }));

    Alpine.data('FilterGroup', () => ({
      SELECTED_FILTERS: SELECTED_FILTERS,
      cache: {},
      filter_type: '',
      filter_values: [],
      flags: {
        is_Brand: false,
        is_Frame: false,
        is_disabled: false,
        is_dropdown: false,
        is_MobileForm: false,
        is_loading: false,
        is_CollectionPage: false
      },
      init() {
        let am = this;
        am.InitSelf();

        // dynamic logic for list updates
        am.UpdateList();
        am.$watch('SELECTED_FILTERS', am.UpdateList.bind(am));
        document.addEventListener('facets:updated', () => {
          SELECTED_FILTERS[am.filter_type] = am.cache.$details.dataset.selected;
          am.SELECTED_FILTERS = {...SELECTED_FILTERS};
        });
      },
      InitSelf() {
        let am = this;
        am.cache.$filtersForm = am.$el.closest('.FacetFiltersForm');
        am.cache.$details = am.$el.querySelector('details');
        am.cache.$select = am.$el.querySelector('select');

        am.filter_type = am.cache.$details.dataset.filter_type;
        am.filter_values = JSON.parse(am.cache.$details.dataset.filter_values);
        SELECTED_FILTERS[am.filter_type] = am.cache.$details.dataset.selected;
        am.SELECTED_FILTERS = {...SELECTED_FILTERS};

        am.UpdateFlags();
      },
      UpdateFlags() {
        let am = this;
        am.flags.is_Brand = am.filter_type == 'brand';
        am.flags.is_Frame = am.filter_type == 'frame';
        am.flags.is_dropdown = am.flags.is_Brand || am.flags.is_Frame;
        am.flags.is_disabled = !am.flags.is_Brand;
        am.flags.is_MobileForm = am.$el.closest('form').id == 'FacetFiltersFormMobile';
        am.flags.is_CollectionPage = document.body.classList.contains('template--collection');
      },
      UpdateList() {
        let am = this;
        if (am.flags.is_Brand && am.flags.is_CollectionPage) {
          // Auto select First "Brand", if only 1 brand on collection (only on collection template)
          setTimeout(() => {
            if (am.flags.is_Brand && am.filter_values.length == 1) {
              let brand = am.filter_values[0];
              if (am.SELECTED_FILTERS['brand'] !== brand) {
                am.cache.$select.value = brand;
                am.cache.$select.dispatchEvent(new Event('change', {bubbles: true}));  
              }
            }  
          }, 0);

          // do not update list if "brand"
          return;
        }

        if (am.flags.is_Frame) {
          am.flags.is_disabled = !am.SELECTED_FILTERS['brand'] && 
            am.SELECTED_FILTERS[am.filter_type] == '';          
          
          // load frames
          if (am.SELECTED_FILTERS['brand'] !== '') {
            document.dispatchEvent(new CustomEvent('clear:frames_list'));
            document.addEventListener('update:frames_list', (e) => {
              setTimeout(() => {
                am.filter_values = [...e.detail.frames];
              }, 0);
            });

            let url_params = new URLSearchParams(window.location.search);
            if (am.SELECTED_FILTERS['frame'] != url_params.get('filter.p.m.product.frame')) {
              am.SELECTED_FILTERS['frame'] = url_params.get('filter.p.m.product.frame')
            }
            let frames_from_cache = SESSION_FRAMES[url_params.get('filter.p.m.product.brand')];
            if (frames_from_cache) {
              document.dispatchEvent(new CustomEvent('update:frames_list', {detail: {frames: frames_from_cache}}));
            }
            else {
              am.LoadFrames();
            }
          }
        }

        // filter out items that lead to 0
        let filter_values = JSON.parse(am.cache.$details.dataset.filter_values);
        let excludes = am.cache.$details.dataset.exclude_values;
        filter_values = filter_values.filter(item => excludes.indexOf(item) == -1);
        am.filter_values = [...filter_values];
      },
      LoadFrames() {
        let am = this;
        const isDesktop = window.matchMedia('(min-width: 749px)').matches;
        if (isDesktop && am.flags.is_MobileForm) return;
        if (!isDesktop && !am.flags.is_MobileForm) return;
        am.flags.is_loading = am.flags.show_framesLoading && true;
        document.dispatchEvent(new CustomEvent('frames:loading:start'));

        console.log(`LoadFrames--for--${ am.SELECTED_FILTERS.brand }!!`);
        LoadFrames(am.SELECTED_FILTERS.brand);        
      },
      e_OnFrameChange(e) {
        let am = this;
        e.stopPropagation();
        e.stopImmediatePropagation();
        console.log('On Frame change!!');
        document.body.dispatchEvent(new CustomEvent('trigger:filter:submit'));
      }
    }));

    Alpine.data('FilterDropdownTop', () => ({
      SELECTED_FILTERS: SELECTED_FILTERS,
      selected: '',
      filter_type: '',
      filter_values: [],
      cache: {},
      flags: {
        is_Brand: false,
        is_Frame: false,
        is_disabled: false,
        is_dropdown: true,
        is_loading: false,
        show_framesLoading: false
      },
      init() {
        let am = this;
        am.filter_type = am.$el.dataset.filter_type;
        am.InitSelf();

        am.flags.is_Brand = am.filter_type == 'brand';
        am.flags.is_Frame = am.filter_type == 'frame';

        if (am.flags.is_Brand) {
          let filter_values = JSON.parse(am.cache.$main_list.dataset.filter_values);
          am.filter_values = [...filter_values];  
          am.selected = am.cache.$main_list.dataset.selected;
          document.addEventListener('facets:updated', () => {
            am.selected = am.cache.$main_list.dataset.selected;
          });
        }

        if (am.flags.is_Frame) {
          document.addEventListener('clear:frames_list', () => {
            am.filter_values = [];
          });

          document.addEventListener('update:frames_list', (e) => {
            am.filter_values = [...e.detail.frames].sort();
            let url_params = new URLSearchParams(window.location.search);
            am.selected = url_params.get('filter.p.m.product.frame');
          });

          ['frames:loading:start', 'frames:loading:complete'].forEach((event_type) => {
            document.addEventListener(event_type, (e) => {
              am.flags.is_loading = am.show_framesLoading && e.type == 'frames:loading:start' ? true : false;
            });
          });  
        }
        am.UpdateFlags();

        document.addEventListener('facets:updated', am.UpdateFlags.bind(am));

        am.$el.removeAttribute('x-cloak-filters');
      },
      InitSelf() {
        let am = this;
        const isDesktop = window.matchMedia('(min-width: 749px)').matches;
        am.cache.$filtersForm = isDesktop ? document.querySelector('#FacetFiltersForm') : document.querySelector('#FacetFiltersFormMobile');
        am.cache.$main_list = am.cache.$filtersForm.querySelector(`details[data-filter_type="${ am.filter_type }"]`);
      },
      UpdateFlags() {
        let am = this;
        am.flags.is_disabled = !am.flags.is_Brand;
        if (am.flags.is_Frame) {
          am.flags.is_disabled = !SELECTED_FILTERS['brand'];
        }
      },
      e_UpdateFilter(e) {
        let am = this;
        let selected = e.target.value;

        // trigger filter selection
        let $main_select = am.cache.$filtersForm.querySelector(`select[name="${ e.target.name }"]`);
        if ($main_select.value !== selected) {
          $main_select.value = selected;
          $main_select.dispatchEvent(new Event('change', {bubbles: true}));  
        }
      }
    }));

    const FRAME_FINDER_SECTION_ID = 'brand-frame-search-dropdown';
    Alpine.data('BrandFrameFinder', () => ({
      flags: {
        loaded: false,
        is_NotCollectionPage: true
      },
      selected: {
        Brand: '',
        Frame: ''
      },
      init() {
        this.InitSelf();
      },
      InitSelf() {
        let am = this;
        am.flags.is_NotCollectionPage = window.location.href.indexOf('/collections/') == -1;
        am.flags.loaded = am.$el.querySelectorAll('[x-data="BrandFrame_FinderItem"]').length !== 0;
        if (am.flags.is_NotCollectionPage && !am.flags.loaded) {
          am.FetchFinderForm();
        }
      },
      async e_FinderResults() {
        let am = this;
        let section_id = 'main-collection-product-grid';
        let collection_url = `/collections/replacement-lenses?filter.p.m.product.brand=${am.selected.Brand}`;
        if (am.selected.Frame) {
          collection_url += `&filter.p.m.product.frame=${am.selected.Frame}`;
        }
        collection_url = encodeURI(collection_url);
        let res_collection = await fetch(`${collection_url}&sections=${section_id}`).then(res => res.json());
        let $res_collection = UTILS.ConvertStringToHTML(res_collection[section_id]);
        let $products = $res_collection.querySelectorAll('.product-item');
        if ($products.length == 1) {
          let product_url = $products[0].dataset.productUrl;
          window.location.href = product_url;
        }
        else {
          window.location.href = collection_url;
        }
      },
      async FetchFinderForm() {
        let am = this;
        let url = `/collections/replacement-lenses?section_id=${FRAME_FINDER_SECTION_ID}`;
        let res_section = await fetch(url).then(res => res.text());
        let $res_section = UTILS.ConvertStringToHTML(res_section).querySelector('[x-data="BrandFrameFinder"]');
        // console.log(res_section, $res_section)
        am.$el.outerHTML = $res_section.outerHTML;
        am.flags.loaded = am.$el.querySelectorAll('[x-data="BrandFrame_FinderItem"]').length !== 0;;
      }
    }));

    Alpine.data('BrandFrame_FinderItem', () => ({
      flags: {
        is_loading: false,
        is_Frame: false
      },
      filter_name: '',
      filter_values: [],
      init() {
        this.InitSelf();
        this.InitWatchers();
      },
      InitSelf() {
        let am = this;
        am.filter_name = am.$el.dataset.filterName;
        am.flags.is_Frame = am.filter_values = am.filter_name == 'Frame';
        am.filter_values = am.flags.is_Frame ? [] : JSON.parse(am.$el.dataset.filterValues);
      },
      InitWatchers() {
        let am = this;
        am.$watch('selected.Brand', () => {
          if (am.flags.is_Frame) {
            am.filter_values = [];
            LoadFrames(am.selected.Brand, FRAME_FINDER_SECTION_ID);
            if (am.flags.is_Frame) {
              am.flags.is_loading = true;
            }
          }
        });

        if (am.flags.is_Frame) {
          document.addEventListener('frames:loading:complete', (e) => {
            // console.log(e);
            am.filter_values = [...e.detail.frames];
            am.flags.is_loading = false;
          });
        }
      }
    }));
  });
})();